import React, { useEffect, useState, useRef } from 'react';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import {
    StarterPackRight,
    StarterPackDescription,
    StarterPackContainer,
    StarterPackTitle,
    StarterPackLeft,
    IconContainer,
    ItemsListContainer,
    ItemsList,
    Item,
    ItemText,
    SVGContainer,
    RightBlockContainer,
    HighlightedText
} from './StarterPackStyle';
import { getSvgComponent } from '../utils/svg';
import StarterPackImages from './StarterPackImages/StarterPackImages';
import { IBlockDescription, IBlock } from '../../types/content';

const getDescription = (description: IBlockDescription) => {
    if (description.stadia && description.luna && description.stadiaLuna) {
        // If anywhereAvailability not available or both values set to false
        if (!window.anywhereAvailability || (window.anywhereAvailability && !window.anywhereAvailability.luna_available && !window.anywhereAvailability.stadia_available)) {
            return "";
        }
        return window.anywhereAvailability.luna_available && window.anywhereAvailability.stadia_available ?
            description.stadiaLuna
            : window.anywhereAvailability.stadia_available ?
                description.stadia
                : description.luna;
    }
    return description.default;
};

const StarterPack = ({ context }: IContext) => {
    //Active states linked by integer for each part of the blocks
    const [activeItem, setActiveItem] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const myRef = useRef<HTMLDivElement>(null);

    const startLoop = () => {
        const position = myRef.current.getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
            setIsVisible(true);
            window.removeEventListener("scroll", startLoop);
        }
    };

    const listBlocks = context.starterPack.block.filter((block: IBlock) => getDescription(block.description));

    useEffect(() => {
        if (!isVisible) {
            window.addEventListener("scroll", startLoop);
        } else {
            setTimeout(() => {
                if (activeItem < listBlocks.length - 1) {
                    setActiveItem(activeItem + 1);
                } else {
                    setActiveItem(0);
                }
            }, 4000);
        }
    }, [activeItem, isVisible]);

    return (
        <StarterPackContainer ref={myRef}>
            <StarterPackLeft>
                <StarterPackTitle>{context.starterPack.title}</StarterPackTitle>
                <StarterPackDescription>
                    {context.starterPack.description}
                </StarterPackDescription>
            </StarterPackLeft>
            <StarterPackRight>
                <RightBlockContainer>
                    <IconContainer>
                        <StarterPackImages
                            currentlyDisplayedImage={activeItem}
                            listBlocks={listBlocks}
                        />
                    </IconContainer>
                    <ItemsListContainer>
                        <ItemsList>
                            {listBlocks.map((block, index) => {
                                const isActive = activeItem === index;
                                const description = getDescription(block.description);
                                return (
                                    <Item
                                        key={`starterPackDescription${index}`}
                                        className={isActive && "active"}
                                    >
                                        <SVGContainer>{getSvgComponent(block.icons.small)}</SVGContainer>
                                            <ItemText dangerouslySetInnerHTML={{ __html: description }}/>
                                            <HighlightedText isActive={isActive}>
                                                <SVGContainer isActive={isActive} highlighted={true}>{getSvgComponent(block.icons.small)}</SVGContainer>
                                                <ItemText dangerouslySetInnerHTML={{ __html: description }}/>
                                            </HighlightedText>
                                        </Item>
                                    );
                                })}
                            </ItemsList>
                        </ItemsListContainer>
                    </RightBlockContainer>
                </StarterPackRight>
            </StarterPackContainer>
    );
};

export default withContent(StarterPack);
